import { getCore } from '../../../../client/core/getCore';
import type { DynamicClient } from '../../../../client/types';
import { checkAndRaiseWalletAccountsChangedEvent } from '../../../auth/updateAuthFromVerifyResponse/checkAndRaiseWalletAccountsChangedEvent';
import type { UnverifiedWalletAccount } from '../unverifiedWalletAccounts.types';

type RemoveUnverifiedWalletAccountParams = {
  unverifiedWalletAccount: UnverifiedWalletAccount;
};

/**
 * Removes an unverified wallet account from the client's state.
 */
export const removeUnverifiedWalletAccount = (
  { unverifiedWalletAccount }: RemoveUnverifiedWalletAccountParams,
  client: DynamicClient
) => {
  const core = getCore(client);

  const previousState = core.state.get();

  const { unverifiedWalletAccounts } = core.state.get();

  const filteredUnverifiedWalletAccounts = unverifiedWalletAccounts.filter(
    (account) => account.id !== unverifiedWalletAccount.id
  );

  core.state.set({
    unverifiedWalletAccounts: filteredUnverifiedWalletAccounts,
  });

  /**
   * We check before raising because the wallet account we are removing might still
   * be present in wallet accounts due to having been moved to verified credentials.
   */
  checkAndRaiseWalletAccountsChangedEvent({ previousState }, client);
};
